// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__Xl0KQ","tip":"styles_tip__x7QVY","slideInSearchBar":"styles_slideInSearchBar__mlJdL"};